'use strict';

(function ($, Drupal) {

  /**
   * Config for the menu.
   *
   * @typedef {Object<string, any>} Config
   * @property {string} menu The outer selector for the whole menu.
   * @property {number} variance The number of pixels after which a menu item
   *   is considered to be hidden from view (and should be added to the popup
   *   menu).
   * @property {string} popup_menu The selector for the popup menu, containing
   *   items not visible on the main menu.
   * @property {string} more_item Selector for the wrapper element containing
   *   both the more_item_button and the popup_menu (it will be hidden when all
   *   items are show in the menu).
   * @property {string} more_item_button Selector for the button the expands
   *   the popup_menu.
   * @property {string} hidden_class Class to apply to hide the sub_menu items.
   * @property {boolean} debug Show debug messaging.
   */

  /**
   * Contains a list of which menus have been initialized. Essentially a hash
   * of ATTACHED[config.menu] = true. Where true means that menu selector has
   * been initialized.
   *
   * If a selector has been initialized it will not be initialized again.
   *
   * @type {{string: boolean}}
   */
  var ATTACHED = {};

  /**
   * Hide the popup menu.
   *
   * @param {Config} config
   * @param {jQuery} $menu
   */
  function hideMenu(config, $menu) {
    $menu.find(config.popup_menu).slideUp('fast');
  }

  /**
   * Used during initialization adds all the menu items to the popup menu so
   * they can be show/hidden depending on whether they are visible on the main
   * menu.
   *
   * Also acts as a primary check to make sure the menu selector works and warns
   * the user if the element is missing.
   *
   * @param {Config} config
   */
  function addElementsToPopupMenu(config) {
    var $menu = $(config.menu);
    if (!$menu.length) {
      // console.log('WARNING: shrinkable menu missing for selector "' + config.menu + '"')
    }
    var popupMenu = $menu.find(config.popup_menu);
    if (popupMenu.find('li').length) {
      return;
    }
    if (!$menu.length) { return; }
    $menu.find(config.items).each(function () {
      $(this).clone().appendTo(popupMenu);
    });
  }

  /**
   * Setup the popup menu's show/hide functionality.
   *
   * @param {Config} config
   */
  function setupPopupMenu(config) {
    var $menu = $(config.menu);
    var $more = $menu.find(config.more_item);
    var $popupMenu = $menu.find(config.popup_menu);
    $popupMenu.hide();
    $more.find(config.more_item_button).click(function () {
      $popupMenu.slideToggle('fast');
    });
    // Hide the menu when somewhere else is clicked.
    $(document).on("click", function(event) {
      var $menu = $(config.menu);
      var $trigger = $menu.find(config.more_item);
      if($trigger !== event.target && !$trigger.has(event.target).length){
        hideMenu(config, $menu);
      }
    });
  }

  /**
   * Called when the menu is initialized and when the page is resized.
   *
   * Adds any menu items no longer visible into the submenu or removes any that
   * are now visible.
   *
   * Also hides the "more" button (which opens the popup menu), if all elements
   * are visible.
   *
   * @param {Config} config
   */
  function fixMenu(config) {
    var $menu = $(config.menu);
    if (!$menu.length) { return; }
    hideMenu(config, $menu);
    var $hiddenItems = $menu.find(config.popup_menu).find('li');
    var count = 0;
    if (config.debug) {
      console.log('- menu position -------------------');
      console.log($menu.position().top);
    }
    $menu.find(config.items).each(function (index) {
      var $elem = $(this);
      var positionFromTop = $elem.position().top - $menu.position().top;
      if (config.debug) {
        console.log('- elem position -------------------');
        console.log('pos: ' + $elem.position().top);
        console.log('positionFromTop: ' + positionFromTop);
        console.log('name: ' + $elem.find('a').text());
      }
      if (positionFromTop > config.variance) {
        $hiddenItems.eq(index).removeClass(config.hidden_class);
        count++;
      } else {
        $hiddenItems.eq(index).addClass(config.hidden_class);
      }
    });
    var $more = $menu.find(config.more_item);
    if (count === 0) {
      $more.addClass(config.hidden_class);
    } else {
      $more.removeClass(config.hidden_class);
    }
  }

  /**
   * Initialize an uninitialized shrinkable menu. Should only be called once on
   * a single selector.
   *
   * @param {Config} config
   */
  function initMenu(config) {
    // Make sure the menu is only initialized once.
    if (ATTACHED[config.menu]) { return; }
    ATTACHED[config.menu] = true;
    // Setup the submenu.
    addElementsToPopupMenu(config);
    setupPopupMenu(config);
    // Fix the menus initial state.
    fixMenu(config);
    // Modify the sub-menu as the page size changes.
    $(window).resize(function () {
      fixMenu(config);
    });
  }

  Drupal.behaviors.shrinkableMenuTmp = {
    attach: function (context, settings) {
      var config = {
        menu: '.blog-category-menu',
        items: 'ul.shrinkable-menu li',
        variance: 50, // item size + menu margin
        popup_menu: '.hidden-elements',
        more_item: '.menu-more',
        more_item_button: '.more-button',
        hidden_class: 'is-hidden',
        debug: false,
      };
      initMenu(config);
    }
  };

})(jQuery, Drupal);
